import { useState } from 'react'
import api from '@/services/api'

interface FlagButtonProps {
  logId: string | undefined
}

export default function FlagButton({ logId }: FlagButtonProps) {
  const [flagged, setFlagged] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  if (!logId) {
    return null
  }

  async function handleFlag() {
    if (flagged || submitting) return
    setSubmitting(true)
    try {
      await api.post('/flag', { log_id: logId })
      setFlagged(true)
    } catch {
      // Keep enabled so the user can retry.
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <button
      type="button"
      onClick={() => void handleFlag()}
      disabled={flagged || submitting}
      className="text-xs text-gray-500 underline-offset-2 transition hover:text-gray-700 hover:underline disabled:cursor-default disabled:text-gray-400 disabled:no-underline"
    >
      {flagged ? 'Flagged' : 'Something look off? Click here to send query to the team.'}
    </button>
  )
}
